angular.module('env.data.batching', [
    'env.data.batching.batchingProvider'
])

    .config(function (batchingProvider) {
        batchingProvider.setConfig({
            enabled: om.config.batching.enabled,
            autoBatching: om.config.batching.autoBatching,
            batchUrl: om.config.build.baseUrl + '/batch'
        });

        batchingProvider.setDefaultBatcherConfig({
            delay: om.config.batching.batchRequestCollectionDelay || 50,
            maxQueueSize: om.config.batching.maxBatchedRequestPerCall || 10,
            minQueueSize: om.config.batching.minimumBatchSize || 2
        });

        batchingProvider.addBatcher({
            url: om.config.build.baseUrl
        });
    })

;